"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userKeeper = exports.coreKeeperAPI = exports.coreKeeperAppReady = exports.getCoreKeeper = void 0;
function getCoreKeeper() {
    return typeof coreKeeper === 'undefined' ? undefined : coreKeeper;
}
exports.getCoreKeeper = getCoreKeeper;
function coreKeeperAppReady(err) {
    var _a;
    (_a = getCoreKeeper()) === null || _a === void 0 ? void 0 : _a.appReady(err);
}
exports.coreKeeperAppReady = coreKeeperAppReady;
function coreKeeperAPI(req, extra) {
    var _a;
    (_a = getCoreKeeper()) === null || _a === void 0 ? void 0 : _a.api(req, extra);
}
exports.coreKeeperAPI = coreKeeperAPI;
function getUserKeeper() {
    return typeof userKeeper !== 'undefined'
        ? userKeeper
        : {
            add: function () {
                /* nothing */
            },
            time: function () {
                /* nothing */
            },
            timeEnd: function () {
                /* nothing */
            },
        };
}
var measureUserTimingGroup = function (label, execture, meta) {
    var keeper = getUserKeeper();
    keeper.time(label);
    var retVal = execture();
    var timeEnd = function () { return keeper.timeEnd(label, meta); };
    if (retVal && typeof retVal.then === 'function') {
        retVal.then(timeEnd, timeEnd);
    }
    else {
        timeEnd();
    }
    return retVal;
};
var proxyUserKeeper = Object.defineProperties({
    group: measureUserTimingGroup,
}, {
    time: {
        get: function () { return getUserKeeper().time; },
    },
    timeEnd: {
        get: function () { return getUserKeeper().timeEnd; },
    },
});
exports.userKeeper = proxyUserKeeper;
//# sourceMappingURL=global.js.map